/* eslint-disable @typescript-eslint/no-empty-function */
import { Body2, ButtonText, CustomizableInlineText } from 'stories/elements/Typography/Text'
import ProfilePicture, { ProfilePictureRaw } from 'components/elements/ProfilePicture'
import { Know } from 'interfaces/Know'
import theme from 'stories/utils/theme'
import styled, { css } from 'styled-components'
import LikeIcon from 'assets/icons/webapp_like.svg'
import ShareIcon from 'assets/icons/webapp_share.svg'
import CopyIcon from 'assets/icons/webapp_copy.svg'
import Arrow from 'assets/icons/back-arrow.svg'
import SaveIcon from 'assets/icons/webapp_save.svg'
import DownloadIcon from 'assets/icons/webapp_download.svg'
import MobileSaveIcon from 'assets/icons/webapp_mobile_save.svg'
import {
    AnalyticsEventKnowConversionComment,
    AnalyticsEventKnowConversionDialogActionButtonClick,
    AnalyticsEventKnowConversionDialogButtonClick,
    AnalyticsEventKnowConversionLike,
    AnalyticsEventKnowConversionSave,
    AnalyticsEventKnowConversionShare,
    AnalyticsEventKnowLike,
    AnalyticsEventKnowRemoveLike,
    AnalyticsEventKnowSaveStart,
    AnalyticsEventKnowShareComplete,
    AnalyticsEventPlusPlanDownloadButtonClick,
    AnalyticsEventPlusPlanDownloadButtonImpression,
    AnalyticsEventPlusPlanDownloadPremiumButtonClick,
    AnalyticsEventProPlanDownloadSeoClick,
    AnalyticsEventProPlanDownloadSeoImpression,
    AnalyticsEventProPlanDownloadWebAppImpression,
    AnalyticsEventProPlanWebAppCTAClick,
} from 'lib/constants/AnalyticsEventType'
import { parseLocale } from 'lib/constants/localization'
import { knowRoute } from 'lib/constants/routes'
import { generateRandomAlphaLetter, getRandomLocalizedComment, handleDownloadKnowContent } from 'lib/features/Know/know'
import { trackEvent } from 'lib/tracking/analytics-service'
import { useRouter } from 'next/router'
import { useEffect, useMemo, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { AppState } from 'redux/reducer'
import _useTranslation from 'lib/hooks/_useTranslation'
import dynamic from 'next/dynamic'
import { redirectToAppDownloadUrlAsync } from 'lib/features/app-links'
import { appDeepLinkKnow } from 'lib/features/app-deep-links'
import { useToggleState } from 'lib/hooks/useToggleState'
import KnowService from 'services/KnowService'
import { ApiError } from 'services/ApiService'
import { KnowComment } from 'interfaces/KnowComment'
import Stack from 'components/elements/Stack'
import { formatDate } from 'lib/formatting/datetime'
import Liked from 'assets/icons/webapp_liked_red.svg'
import AddKnowToFolderDialog from 'components/feature/App/modules/folder/AddKnowToFolderDialog'
import { CountryCode } from 'interfaces/Country'
import { toast } from 'react-toastify'
import FeatureDialog from 'stories/elements/Modal/DialogWindow/FeatureDialog'
import NewButton from 'components/elements/NewButton'
import { copyTextToClipboard, handleShare } from 'lib/features/coping'
import { isDeviceMobile } from 'lib/features/deviceInfo'
import useImpressionTracking from 'lib/hooks/useImpressionTracking'
import { getCountryConfig } from 'lib/constants/countryconfig'
import { getMobileOS } from 'lib/tracking/attribution/device'
import { storeKnowToDownload } from 'lib/tracking/storage'
import { generateRandom10CharacterString } from 'lib/tracking/attribution/uuid'
import { FormGroup } from 'components/elements/Inputs/Input.css'
import KnowSubComments from '../webapp/KnowSubComments'
import { getTotalReactionCount } from 'lib/features/forum-discussion'
import Row from 'components/elements/Row'
import { UserPremiumStatus } from 'interfaces/User'
import ReportDialog from 'components/feature/Reports/ReportDialog'
import { ReportType } from 'interfaces/UserReport'
import { ClientOnly } from 'components/elements/ClientOnly'
import { KnowSeoInfo } from 'interfaces/KnowSeoInfo'
import MonetizationRedirectDialog from 'lib/features/Pro/MonetizationRedirectDialog'
import DownloadAsset from 'assets/app/knows/download-asset.png'

const WebappConversionDialog = dynamic(() => import('../webapp/WebappConversionDialog'))

const ReactionWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    gap: 10px;
`

const CommentSection = styled.div<{ showBorder?: boolean; showCursor?: boolean; hasComments?: boolean }>`
    display: flex;
    align-items: center;
    gap: 10px;
    border-radius: ${theme.borderRadius.normal};

    ${({ showBorder, showCursor, hasComments }) =>
        showBorder
            ? css`
                  padding: 15px 25px;
                  background-color: ${hasComments ? theme.colors.backgroundTransparent : theme.colors.transparent};
                  display: grid;
                  align-items: start;
                  position: relative;
                  width: 100%;
                  min-height: 100px;
                  cursor: ${showCursor ? 'pointer' : 'auto'};
                  .comment {
                      display: grid;
                      align-items: center;
                      grid-template-columns: auto 1fr;
                      gap: 10px;
                      padding-bottom: 5px;
                      * {
                          word-break: break-word;
                      }
                  }
                  .desktop-comment {
                      display: grid;
                      grid-template-columns: auto 1fr;
                      gap: 15px;
                      place-items: start;
                      .avatar {
                          position: relative;
                          top: 11px;
                          left: 2px;
                      }
                  }
                  @media (max-width: 1050px) {
                      padding: 15px 10px;
                  }
              `
            : ''}
`

const ActionsSection = styled.div<{ changeLayout?: boolean }>`
    display: flex;
    gap: 10px;
    padding: 0px;
    align-items: center;
    .join {
        ${({ changeLayout }) =>
            changeLayout
                ? css`
                      display: grid;
                      grid-template-columns: 1fr 1fr 1fr 1fr;
                  `
                : css`
                      display: flex;
                  `}

        gap: 10px;
    }
    .desktop-report {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .report {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    @media (max-width: 1050px) {
        width: 100%;
        justify-content: center;
        gap: 20px;
        flex-wrap: wrap;
    }
`

const ActionWrapper = styled.div<{ isDarkTheme?: boolean; isDownloadButton?: boolean }>`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    border: 1px solid ${theme.colors.actionGray};
    background-color: ${theme.colors.white};
    padding: 5px 10px;
    height: ${({ isDarkTheme }) => (isDarkTheme ? '40px' : 'fit-content')};
    border-radius: ${theme.borderRadius.webappCard};
    @media (max-width: 750px) {
        border: 1px solid ${theme.colors.violet};
    }

    @media (max-width: 750px) {
        border: 1px solid ${theme.colors.placeholderText};
        p {
            font-size: 15px;
        }
    }

    ${({ isDarkTheme }) =>
        isDarkTheme
            ? css`
                  border: none;
                  padding: 8px 10px;
                  background-color: ${theme.colors.backgroundTransparent};
                  p {
                      color: ${theme.colors.white};
                  }
                  svg path {
                      stroke: ${theme.colors.grayScaleSecondary};
                  }
              `
            : ''}

    ${({ isDownloadButton }) =>
        isDownloadButton
            ? css`
                  background: radial-gradient(120.61% 148.67% at -20.61% -9.6%, #50b354 0%, #0075c2 100%)
                          /* warning: gradient uses a rotation that is not supported by CSS and may not behave as expected */,
                      radial-gradient(50% 50% at 50% 0%, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0) 100%);
                  padding: 8px 25px;
              `
            : ''}
`

const CommentsTitle = styled.div<{ hideCursor?: boolean }>`
    display: flex;
    align-items: center;
    cursor: ${({ hideCursor }) => (hideCursor ? 'auto' : 'pointer')};
    padding: 5px;
    gap: 10px;
    h3 {
        margin: 0;
        font-family: var(--font-inter);
        font-weight: 600;
        color: ${theme.colors.white};
        font-size: 16px;
    }
    @media (max-width: 1050px) {
        justify-content: space-between;
    }
`

const ActionArea = styled.div`
    position: relative;
`

const ShowMoreIcon = styled(Arrow)`
    transform: rotate(270deg);
    @media (max-width: 1050px) {
        transform: rotate(180deg);
    }
`

const ShareRow = styled.div`
    display: flex;
    justify-content: center;
    gap: 10px;
    input {
        width: 300px !important;
    }
    svg {
        fill: transparent;
    }
    align-items: center;
`

interface Props {
    isMobile: boolean
    knowSeoInfo: KnowSeoInfo
    showPreview: boolean
    referrerScreen?: string
    removeDesktopCommentSection?: boolean
    removeContentActionsSection?: boolean
    showWebappActions?: boolean
    onActionClicked?: (type: 'Like' | 'Comment' | 'Save' | 'Share') => void
    isDarkTheme?: boolean
}

const KnowActions = ({
    knowSeoInfo,
    isMobile,
    showPreview,
    referrerScreen,
    removeDesktopCommentSection,
    removeContentActionsSection,
    showWebappActions,
    onActionClicked,
    isDarkTheme,
}: Props) => {
    const [know, setInternalKnow] = useState<Know>(knowSeoInfo.know)
    const [showAddKnowToFolderDialog, toggleAddKnowToFolderDialog] = useToggleState(false)
    const [showConversionDialog, toggleConversionDialog] = useToggleState(false)
    const [showShareDialog, toggleShareDialog] = useToggleState(false)
    const [knowShareLink, setKnowShareLink] = useState<string>('')
    const [comments, setComments] = useState<KnowComment[]>()
    const authenticatedUser = useSelector((state: AppState) => state.user)
    const { t: tCommon } = _useTranslation('common')
    const { t } = _useTranslation('knows')
    const { t: tPlusPlan } = _useTranslation('plusPlan')
    const router = useRouter()
    const [showMonetizationRedirectDialog, toggleMonetizationRedirectDialog] = useToggleState(false)

    const downloadButtonRef = useRef<HTMLDivElement>(null)

    const downloadProEntryPointsButtonRef = useRef<HTMLDivElement>(null)
    const parsedLocale = parseLocale(router.locale)
    const [conversionDialogHeadingCopy, setConversionDialogHeading] = useState<string>(
        t('knows/conversionDialogExperimentVariantHeading')
    )
    const isOSMobile = useMemo(() => isDeviceMobile(), [])
    const knowShareSID = useMemo(() => generateRandom10CharacterString(), [])

    const { hasPlusPlan } = getCountryConfig(parsedLocale.countryCode)

    const skipMobileConversionDialog = isOSMobile && !showPreview && !authenticatedUser

    const showDownloadPlusPlanButton = hasPlusPlan && !isOSMobile

    useImpressionTracking(
        downloadProEntryPointsButtonRef,
        showWebappActions ? AnalyticsEventProPlanDownloadWebAppImpression : AnalyticsEventProPlanDownloadSeoImpression,
        { know, referrerScreen: showWebappActions ? 'web_app' : 'seo_page' },
        showDownloadPlusPlanButton
    )

    useImpressionTracking(
        downloadButtonRef,
        AnalyticsEventPlusPlanDownloadButtonImpression,
        { know, referrerScreen: showWebappActions ? 'web_app' : 'seo_page' },
        showDownloadPlusPlanButton
    )

    const allowSocialAction = parsedLocale.countryCode === CountryCode.UnitedStates && authenticatedUser

    const showCommentsSectionOnDesktop = !!removeContentActionsSection
    const showCommentsSection = isMobile && !showPreview
    const commenterName = useMemo(() => generateRandomAlphaLetter(), [])
    const commentText = useMemo(() => getRandomLocalizedComment(parsedLocale), [parsedLocale])
    const showDummyComments = (!comments?.length || !authenticatedUser) && !showPreview

    // useEffect(() => {
    //     if (!(showDownloadPlusPlanButton && showProFunnelEntryPoints)) return

    //     trackEvent(
    //         showWebappActions ? AnalyticsEventProPlanDownloadWebAppImpression : AnalyticsEventProPlanDownloadSeoImpression,
    //         {}
    //     )
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [showProFunnelEntryPoints])

    const handleLikeKnowClicked = () => {
        const wasKnowLiked = know?.liked
        const handleFunc = wasKnowLiked ? KnowService.removeKnowLike(know.uuid) : KnowService.likeKnow(know.uuid)

        handleFunc
            .then(() => {
                setInternalKnow((know) => ({ ...know, liked: !wasKnowLiked, likes: know.likes + (wasKnowLiked ? -1 : 1) }))
                trackEvent(wasKnowLiked ? AnalyticsEventKnowRemoveLike : AnalyticsEventKnowLike, { know })
                !wasKnowLiked && toast.success(t('knows/likeToastMessage'))
            })
            .catch((error) => {
                if (error instanceof ApiError) {
                    error.handleUnknownError(tCommon, 'know.getKnowComments')
                } else {
                    throw error
                }
            })
    }

    useEffect(() => {
        setKnowShareLink(
            `${document.location.host}${knowRoute(know.slug, {
                referrer: 'webshare',
                sid: knowShareSID,
            })}`
        )
    }, [know.slug, knowShareSID])

    useEffect(() => {
        if (!authenticatedUser) return

        KnowService.getKnowComments(know.uuid)
            .then((comments) => {
                const commentList = showPreview ? comments : comments.slice(0, 3)
                setComments(commentList)
            })
            .catch((error) => {
                if (error instanceof ApiError) {
                    error.handleUnknownError(tCommon, 'know.getKnowComments')
                } else {
                    throw error
                }
            })
    }, [authenticatedUser, know.uuid, showPreview, tCommon])

    useEffect(() => {
        setInternalKnow(knowSeoInfo.know)
    }, [knowSeoInfo.know])

    const handleDynamicCopyChange = (source: 'Like' | 'Comment' | 'Save' | 'Share') => {
        setConversionDialogHeading(t(`knows/conversionDialogExperimentVariantHeading${source}Variant`))
    }

    const openConversionDialog = (source?: 'Like' | 'Comment' | 'Save' | 'Share') => {
        toggleConversionDialog()
        source && handleDynamicCopyChange(source)
    }

    const handleConversionDialogActionButtonClick = (platform: 'android' | 'ios') => {
        trackEvent(AnalyticsEventKnowConversionDialogActionButtonClick, {
            know: know ?? undefined,
            useBeacon: true,
            referrerScreen,
        })
        redirectToAppDownloadUrlAsync(platform, 'knowSeoPage', appDeepLinkKnow(know.uuid))
    }

    const closeConversionDialog = () => {
        toggleConversionDialog()
        setTimeout(() => {
            setConversionDialogHeading(t(`knows/conversionDialogExperimentVariantHeading`))
        }, 500)
    }

    const conversionDialogButtonClick = (source?: 'Like' | 'Comment' | 'Save' | 'Share') => {
        trackEvent(AnalyticsEventKnowConversionDialogButtonClick, {
            know: know ?? undefined,
            useBeacon: true,
            referrerScreen,
        })
        onActionClicked && source && onActionClicked(source)
        if (skipMobileConversionDialog) {
            redirectToAppDownloadUrlAsync(getMobileOS() ?? 'ios', 'knowSeoPage', appDeepLinkKnow(know.uuid))
        } else {
            openConversionDialog(source)
        }
    }

    const likeConversionHandleClick = () => {
        if (allowSocialAction) {
            handleLikeKnowClicked()
        } else {
            trackEvent(AnalyticsEventKnowConversionLike, { know, referrerScreen })
            conversionDialogButtonClick('Like')
        }
    }

    const handleShareOnMobile = () => handleShare({ text: knowShareLink }, toggleAddKnowToFolderDialog, handleShareComplete)

    const saveConversionHandleClick = () => {
        if (showWebappActions) {
            isOSMobile ? handleShareOnMobile() : toggleAddKnowToFolderDialog()
            trackEvent(AnalyticsEventKnowSaveStart, { know, referrerScreen })
        } else {
            trackEvent(AnalyticsEventKnowConversionSave, { know, referrerScreen })
            conversionDialogButtonClick('Save')
        }
    }

    const handleShareComplete = () =>
        trackEvent(AnalyticsEventKnowShareComplete, { know, value: knowShareLink, referrerScreen })

    const shareConversionHandleClick = () => {
        if (allowSocialAction) {
            toggleShareDialog()
            trackEvent(AnalyticsEventKnowConversionShare, { know, value: knowShareSID, referrerScreen })
        } else {
            trackEvent(AnalyticsEventKnowConversionShare, { know, referrerScreen })
            conversionDialogButtonClick('Share')
        }
    }

    const copyKnowLink = () => {
        copyTextToClipboard(knowShareLink, t('knows/copiedToastMessage'))
        trackEvent(AnalyticsEventKnowShareComplete, { know, value: knowShareLink, referrerScreen })
        toggleShareDialog()
    }

    const commentConversionHandleClick = () => {
        if (showPreview) return
        trackEvent(AnalyticsEventKnowConversionComment, { know, referrerScreen })
        conversionDialogButtonClick('Comment')
    }

    const handleDownloadPlusPlanClick = async () => {
        const plusReferrerScreen = showWebappActions ? 'web_app' : 'seo_page'

        const experimentPlusPlanEntryReferrerScreen = showWebappActions ? 'proDownloadWebApp' : 'proDownloadSEO'

        const isUserAllowedToDownloadContent =
            !!authenticatedUser && authenticatedUser?.premiumStatus !== UserPremiumStatus.None

        if (isUserAllowedToDownloadContent) {
            handleDownloadKnowContent(know)
            trackEvent(AnalyticsEventPlusPlanDownloadPremiumButtonClick, {
                know,
                referrerScreen: plusReferrerScreen,
            })
        } else {
            trackEvent(showWebappActions ? AnalyticsEventProPlanWebAppCTAClick : AnalyticsEventProPlanDownloadSeoClick, {
                referrerScreen: experimentPlusPlanEntryReferrerScreen,
            })

            storeKnowToDownload(know)
            trackEvent(AnalyticsEventPlusPlanDownloadButtonClick, {
                know,
                referrerScreen: plusReferrerScreen,
            })

            toggleMonetizationRedirectDialog()
        }
    }

    return (
        <ActionArea>
            <MonetizationRedirectDialog
                isOpen={showMonetizationRedirectDialog}
                onClose={toggleMonetizationRedirectDialog}
                title={tPlusPlan('plusPlan/monetizationDialogDownloadTitle')}
                image={DownloadAsset}
                type="download"
            />
            <CommentSection
                showCursor={showDummyComments}
                showBorder={showCommentsSectionOnDesktop}
                onClick={removeContentActionsSection ? commentConversionHandleClick : () => {}}
                data-nosnippet="true"
                className="dummy-section"
                hasComments={!!comments?.length}
            >
                {!isMobile && !removeDesktopCommentSection && showCommentsSectionOnDesktop ? (
                    <>
                        {comments?.length || !showPreview ? (
                            <CommentsTitle onClick={commentConversionHandleClick} hideCursor={showPreview}>
                                <h3>{t('knows/knowDetailsComments')}</h3>
                            </CommentsTitle>
                        ) : null}
                        {showCommentsSectionOnDesktop ? (
                            <>
                                {showDummyComments ? (
                                    <div className="comment">
                                        <ProfilePictureRaw name={commenterName} profilePicture={null} />
                                        <ClientOnly>
                                            <Body2
                                                fontFamily="var(--font-inter)"
                                                fontWeight={400}
                                                color={theme.colors.grayScaleSecondary}
                                            >
                                                {commentText}
                                            </Body2>
                                        </ClientOnly>
                                    </div>
                                ) : (
                                    <>
                                        {comments?.length
                                            ? comments?.map((comment) => (
                                                  <div className="desktop-comment" key={comment.uuid}>
                                                      <div className="avatar">
                                                          <ProfilePicture user={comment.user} />
                                                      </div>
                                                      <Stack gutter={5}>
                                                          <ButtonText
                                                              fontFamily="var(--font-inter)"
                                                              fontWeight={600}
                                                              color={theme.colors.white}
                                                          >
                                                              {comment.user.username}
                                                              {'⠀'}
                                                              <CustomizableInlineText
                                                                  fontWeight={300}
                                                                  hideCursor
                                                                  color={theme.colors.white}
                                                              >
                                                                  {formatDate(comment.createdOn)}
                                                              </CustomizableInlineText>
                                                          </ButtonText>
                                                          <Body2
                                                              fontFamily="var(--font-inter)"
                                                              fontWeight={400}
                                                              color={theme.colors.grayScaleSecondary}
                                                          >
                                                              {comment.content}
                                                          </Body2>
                                                          <ReactionWrapper>
                                                              <Row gap={10}>
                                                                  <Liked />
                                                                  <ButtonText
                                                                      fontFamily="var(--font-inter)"
                                                                      fontWeight={300}
                                                                      color={theme.colors.grayScaleSecondary}
                                                                  >
                                                                      {getTotalReactionCount(comment.reactions)}
                                                                  </ButtonText>
                                                              </Row>
                                                              <KnowSubComments comment={comment} isDarkTheme={isDarkTheme} />
                                                          </ReactionWrapper>
                                                      </Stack>
                                                  </div>
                                              ))
                                            : null}
                                    </>
                                )}
                            </>
                        ) : null}
                    </>
                ) : null}
                {!removeContentActionsSection ? (
                    <ActionsSection changeLayout={showDownloadPlusPlanButton && showWebappActions}>
                        <div className="join">
                            <ActionWrapper
                                onClick={likeConversionHandleClick}
                                isDarkTheme={showWebappActions || isDarkTheme}
                            >
                                {know.liked ? <Liked /> : <LikeIcon />}
                                <ButtonText fontFamily="var(--font-inter)" fontWeight={600} color={theme.colors.actionGray}>
                                    {know.likes}
                                </ButtonText>
                            </ActionWrapper>
                            <ActionWrapper
                                onClick={shareConversionHandleClick}
                                isDarkTheme={showWebappActions || isDarkTheme}
                            >
                                <ShareIcon />
                                <ButtonText fontFamily="var(--font-inter)" fontWeight={600} color={theme.colors.actionGray}>
                                    {tCommon('common/share')}
                                </ButtonText>
                            </ActionWrapper>
                            {!isMobile ? (
                                <>
                                    <ActionWrapper
                                        onClick={saveConversionHandleClick}
                                        isDarkTheme={showWebappActions || isDarkTheme}
                                    >
                                        <SaveIcon />
                                        <ButtonText
                                            fontFamily="var(--font-inter)"
                                            fontWeight={600}
                                            color={theme.colors.actionGray}
                                        >
                                            {tCommon('common/save')}
                                        </ButtonText>
                                    </ActionWrapper>

                                    {showDownloadPlusPlanButton ? (
                                        <div ref={downloadButtonRef}>
                                            <div ref={downloadProEntryPointsButtonRef}>
                                                <ActionWrapper
                                                    onClick={handleDownloadPlusPlanClick}
                                                    isDownloadButton
                                                    isDarkTheme={showWebappActions || isDarkTheme}
                                                >
                                                    <DownloadIcon />
                                                    <ButtonText
                                                        fontFamily="var(--font-inter)"
                                                        fontWeight={600}
                                                        color={theme.colors.white}
                                                    >
                                                        {t('knows/plusPlanDownloadCTAButton')}
                                                    </ButtonText>
                                                </ActionWrapper>
                                            </div>
                                        </div>
                                    ) : null}

                                    {!showWebappActions ? (
                                        <div className="desktop-report">
                                            <ReportDialog
                                                reportType={ReportType.know}
                                                reportedUserUuid={know.knower.user.uuid}
                                                know={know}
                                            />
                                        </div>
                                    ) : null}
                                </>
                            ) : null}
                        </div>
                        {isMobile ? (
                            <Row gap={5}>
                                <ActionWrapper onClick={saveConversionHandleClick}>
                                    <ButtonText
                                        fontFamily="var(--font-inter)"
                                        fontWeight={600}
                                        color={theme.colors.actionGray}
                                    >
                                        {tCommon('common/save')}
                                    </ButtonText>
                                    <MobileSaveIcon />
                                </ActionWrapper>
                                <div className="report">
                                    <ReportDialog
                                        reportType={ReportType.know}
                                        reportedUserUuid={know.knower.user.uuid}
                                        know={know}
                                    />
                                </div>
                            </Row>
                        ) : null}
                    </ActionsSection>
                ) : null}
            </CommentSection>

            {showCommentsSection ? (
                <CommentSection showBorder onClick={showDummyComments ? commentConversionHandleClick : () => {}}>
                    <CommentsTitle>
                        <h3>{`${t('knows/knowDetailsComments')} (${know.commentsCount + 1})`}</h3>
                        <ShowMoreIcon />
                    </CommentsTitle>
                    {showDummyComments ? (
                        <>
                            <div className="comment">
                                <ProfilePictureRaw name={commenterName} profilePicture={null} />
                                <ClientOnly>
                                    <Body2 fontFamily="var(--font-inter)" fontWeight={400} color={theme.colors.white}>
                                        {commentText}
                                    </Body2>
                                </ClientOnly>
                            </div>
                        </>
                    ) : (
                        <>
                            {comments?.length
                                ? comments?.map((comment) => (
                                      <div className="comment" key={comment.uuid}>
                                          <ProfilePicture user={comment.user} />
                                          <Body2
                                              fontFamily="var(--font-inter)"
                                              fontWeight={400}
                                              color={theme.colors.grayScaleSecondary}
                                          >
                                              {comment.content}
                                          </Body2>
                                      </div>
                                  ))
                                : null}
                        </>
                    )}
                </CommentSection>
            ) : null}
            {know && showAddKnowToFolderDialog ? (
                <AddKnowToFolderDialog
                    know={know}
                    open={showAddKnowToFolderDialog}
                    onClose={toggleAddKnowToFolderDialog}
                    isDarkTheme={isDarkTheme}
                />
            ) : null}
            {know && showConversionDialog ? (
                <WebappConversionDialog
                    open={showConversionDialog}
                    title={conversionDialogHeadingCopy}
                    handleClose={closeConversionDialog}
                    onButtonClick={handleConversionDialogActionButtonClick}
                    downloadDeepLinkPath={appDeepLinkKnow(know.uuid)}
                    know={know}
                    referrerScreen={referrerScreen}
                />
            ) : null}
            {know && showShareDialog ? (
                <FeatureDialog
                    open={showShareDialog}
                    onClose={toggleShareDialog}
                    ariaPrefix="share-know"
                    title={tCommon('common/share')}
                    maxWidth={450}
                >
                    <ShareRow>
                        <FormGroup noMargin>
                            <label>
                                <input defaultValue={knowShareLink} id="link" disabled />
                            </label>
                        </FormGroup>
                        <NewButton
                            height={60}
                            color={theme.colors.deepSeaBlue}
                            type="secondary"
                            borderRadius={theme.borderRadius.normal}
                            icon={<CopyIcon />}
                            onClick={copyKnowLink}
                        >
                            <ButtonText color={theme.colors.deepSeaBlue}>{t('knows/copyButtonText')}</ButtonText>
                        </NewButton>
                    </ShareRow>
                </FeatureDialog>
            ) : null}
        </ActionArea>
    )
}

export default KnowActions
